const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'propertiesForm',
    ],

    config: {
        entityContext: 'tripCostCenters',
    },

    model: {
        fieldComponents: {},
    },

    hooks: {
        onChange($element, options){

            const {
                fieldCode,
                value,
                valueByUser,
            } = (options || {})
            const values = {}
            let priceRelevantFieldChanged = false

            // if a user sets a field value null all possible automatic calculations would be unwanted.
            if(value === null){
                return
            }

            // to prevent endless loops of corrections => round-off-errors => followup-corrections the calculations stop after the first user-input.
            if(!valueByUser){
                return
            }

            for(const f of ['price', 'netPrice', 'vat']){
                priceRelevantFieldChanged = priceRelevantFieldChanged || fieldCode === f

                if(!this.model.fieldComponents[f]){
                    this.find('base_form_fields_text', c => {
                        if(c.model.fieldCode === f){
                            this.model.fieldComponents[f] = c
                        }
                    })
                }

                if(f === fieldCode){
                    values[f] = value
                } else if(this.model.fieldComponents[f]) {
                    values[f] = this.model.fieldComponents[f].model.data
                } else {
                    values[f] = this.getFieldValue(f)
                }
            }

            let newValue

            if(priceRelevantFieldChanged && values.vat !== undefined && (values.price !== undefined || values.netPrice !== undefined)){
                const vatFactor = 1 + utils.number.round((values.vat || 0) / 100, 3)

                if(
                    (fieldCode === 'price' && (values.vat || values.vat === 0))
                    ||
                    (fieldCode === 'vat' && (values.price || values.price === 0))
                ){
                    this.model.fieldComponents.netPrice.updateValue(
                        (newValue = utils.number.round(values.price / vatFactor, 2)),
                        true,
                        false
                    )
                } else if(
                    (fieldCode === 'netPrice' && (values.vat || values.vat === 0))
                    ||
                    (fieldCode === 'vat' && (values.netPrice || values.netPrice === 0))
                ){
                    this.model.fieldComponents.price.updateValue(
                        (newValue = utils.number.round(values.netPrice * vatFactor, 2)),
                        true,
                        false
                    )
                }
            }
        }
    }
}